module.exports = __webpack_public_path__ + "static/img/pro7_tab1.62c2757.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro7_tab1.jpg
// module id = DNJn
// module chunks = 171